import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
}
const MafoQuestionEight: React.FC<MafoQuestionProps> = ({ register, errors }) => {
	return (
		<>
			<h3 className="mafo-headline text-left text-blue">8. Wenn Du TREK Protein Oat Bars bereits probiert hast: Wie zufrieden bist Du mit dem Geschmack?</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Sehr zufrieden</>} className=" question8 pb-2 text-green">
					<input type="radio" {...register("question8")} name="question8" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question8 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Eher zufrieden</>} className=" question8 pb-2 text-green">
					<input type="radio" {...register("question8")} name="question8" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question8 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Teils/teils</>} className=" question8 pb-2 text-green">
					<input type="radio" {...register("question8")} name="question8" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question8 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Eher unzufrieden</>} className=" question8 pb-2 text-green">
					<input type="radio" {...register("question8")} name="question8" value="d" className={"peer absolute hidden h-1 w-1 " + (errors.question8 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Sehr unzufrieden</>} className=" question8 pb-2 text-green">
					<input type="radio" {...register("question8")} name="question8" value="e" className={"peer absolute hidden h-1 w-1 " + (errors.question8 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Noch nicht probiert</>} className=" question8 pb-2 text-green">
					<input type="radio" {...register("question8")} name="question8" value="f" className={"peer absolute hidden h-1 w-1 " + (errors.question8 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
			</div>
		</>
	)
}

export default MafoQuestionEight
